<div class="chat-layout border-1 surface-border border-round overflow-hidden bg-white">
  <div
    class="chat-layout__panel chat-layout__lista"
    [class.chat-layout__panel--oculto]="detalleAbierto()"
  >
    <ng-content select="[chatLista]" />
  </div>

  <div
    class="chat-layout__panel chat-layout__detalle"
    [class.chat-layout__panel--oculto]="!detalleAbierto()"
  >
    <ng-content select="[chatDetalle]" />
  </div>
</div>
